module.exports = __webpack_public_path__ + "assets/938c72a211be2289521d6360e72533e6.png";